export default __webpack_public_path__ + "static/media/arrowdrop.64fa73ce.svg";